import createReactComponent from '../createReactComponent';
var SortAsc = createReactComponent('SortAsc', [['path', {
  d: 'M11 11H15',
  key: '13b0h1'
}], ['path', {
  d: 'M11 15H18',
  key: '14lp16'
}], ['path', {
  d: 'M11 19H21',
  key: '1cy3wr'
}], ['path', {
  d: 'M9 7L6 4L3 7',
  key: 'bjdqf3'
}], ['path', {
  d: 'M6 6L6 20',
  key: '1aagpo'
}]]);
export default SortAsc;